<template>
  <div class="mobile-forum">
    <div v-loading="loading"></div>
    <div class="mobile-forum-nav">
      <div class="item" :class="{actived: $route.name == 'Article'}" @click="toSec('/Home/ForumSec/Article')">
        <svg-icon icon-class="write" v-if="$route.name !== 'Article'"></svg-icon>
        <svg-icon icon-class="write_a" v-else></svg-icon>
        发布新帖
      </div>
      <div class="item" :class="{actived: $route.name == 'Post'}" @click="toSec('/Home/ForumSec/Post')">
        <svg-icon icon-class="post" v-if="$route.name !== 'Post'"></svg-icon>
        <svg-icon icon-class="post_a" v-else></svg-icon>
        我的帖子
      </div>
      <div class="item" :class="{actived: $route.name == 'Message'}" @click="toSec('/Home/ForumSec/Message')">
        <svg-icon icon-class="message" v-if="$route.name !== 'Message'"></svg-icon>
        <svg-icon icon-class="message_a" v-else></svg-icon>
        互动消息
      </div>
    </div>
    <div class="search-box">
      <div class="search-input">
        <svg-icon icon-class="newsearch" class="icon" @click.native="search"></svg-icon>
        <input class="input" type="text" v-model="pageParams.title" @keyup.enter="search" />
      </div>
      <div class="search-filter" @click="handleShowFilter">
        筛选
        <svg-icon icon-class="filter"></svg-icon>
      </div>
      <van-popup v-model="showFilter" round position="bottom">
        <div class="popup-box">
          <div class="popup-item">
            <div class="title">产品</div>
            <div class="tags">
              <div class="tag" :class="{selected: selectedProductType == item.value}" v-for="item in productList_mobile" :key="item.text" @click="handleClickProduct(item)">{{ item.text }}</div>
            </div>
          </div>
          <div class="popup-item">
            <div class="title">分类</div>
            <div class="tags">
              <div class="tag" :class="{selected: selectedCategoryType == 0}" @click="handleClickCategory(0)">热榜</div>
              <div class="tag" :class="{selected: selectedCategoryType == 1}" @click="handleClickCategory(1)">实时</div>
              <div class="tag" :class="{selected: selectedCategoryType == 2}" @click="handleClickCategory(2)">问答</div>
              <div class="tag" v-if="showHmiTestTab" :class="{selected: selectedCategoryType == 3}" @click="handleClickCategory(3)">大学生化工设计竞赛</div>
              <div class="tag" v-if="showHmiChinaTab" :class="{selected: selectedCategoryType == 4}" @click="handleClickCategory(4)">HMI 中国版</div>
            </div>
          </div>
          <div class="popup-btn-box">
            <div class="btn" @click="handleClickFilterReset">重置</div>
            <div class="btn cur" @click="handleClickFilterConfirm">确定</div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="list-box" v-if="pageList.length">
      <div class="list-item" v-for="(item, index) in pageList" :key="item.id">
        <img src="@/assets/PC/forum/rank_icon_0.png" class="rank_icon inner" v-if="item.isTop"/>
        <template v-else-if="categoryType == 0">
          <img src="@/assets/PC/forum/rank_icon_1.png" class="rank_icon" v-if="item.sort == 1"/>
          <img src="@/assets/PC/forum/rank_icon_2.png" class="rank_icon" v-else-if="item.sort == 2"/>
          <img src="@/assets/PC/forum/rank_icon_3.png" class="rank_icon" v-else-if="item.sort == 3"/>
          <img src="@/assets/PC/forum/rank_icon_4.png" class="rank_icon inner" v-else-if="item.sort == 4"/>
          <img src="@/assets/PC/forum/rank_icon_5.png" class="rank_icon inner" v-else-if="item.sort == 5"/>
        </template>
        <div class="item-info">
          <div class="avatar" v-if="item.pictureUrl">
            <img :src="item.pictureUrl" alt="">
          </div>
          <div class="info">
            <div class="name">
              <span>{{item.author}}</span>
              <div class="aveva-badge" v-if="item.level" :style="{'background-image': `url(${item.level.app_bck})`}">{{ item.level.levelName }}</div>
            </div>
            <div class="time">发布于 {{ item.publishDateString }}</div>
          </div>
        </div>
        <div class="item-text" @click="toDetails(item.id)">
          <div class="title">{{ item.title }}</div>
          <div class="text">
            {{ item.introduction }}
            <div class="more" v-if="item.introduction.length > 138">...全文</div>
          </div>
        </div>
        <div class="item-imgs" v-if="item.imageUrls && typeof(item.imageUrls) == 'string'" @click="toDetails(item.id)">
          <img :src="img" alt="" v-for="img in item.imageUrls.split(',')" :key="img">
        </div>
        <div class="item-control-box">
          <a class="item" @click="like(item)" :class="[item.isLike ? 'active' : '']" title="点赞">
            <svg-icon icon-class="sword" v-if="!item.isLike"></svg-icon>
            <svg-icon icon-class="sword_a" v-else></svg-icon>
            <span class="text">{{ item.likeCount }}</span>
          </a>
          <a class="item" @click="collect(item)" :class="[item.isCollect ? 'active' : '']" title="收藏">
            <svg-icon icon-class="shield" v-if="!item.isCollect"></svg-icon>
            <svg-icon icon-class="shield_a" v-else></svg-icon>
            <span class="text">{{ item.collectCount }}</span>
          </a>
          <a class="item" :class="[item.isComment ? 'active' : '']" title="评论">
            <svg-icon icon-class="discuss" v-if="!item.isComment"></svg-icon>
            <svg-icon icon-class="discuss_a" v-else></svg-icon>
            <span class="text">{{ item.comment }}</span>
          </a>
          <a class="item" title="转发">
            <svg-icon icon-class="share"></svg-icon>
            <span class="text">{{ item.shareNum }}</span>
            <ul class="share-list">
              <li>
                <img src="../../assets/PC/forum/icon_copy.png" alt="" />
                <span v-clipboard:copy="item.link" v-clipboard:success="onCopy">复制链接</span>
              </li>
              <li>
                <img src="../../assets/PC/forum/icon_sina.png" alt="" />
                <span @click="toSina(item.title, item.id)">新浪微博</span>
              </li>
            </ul>
          </a>
        </div>
      </div>
    </div>
    <div v-else class="noData">
      <img src="@/assets/PC/profile/listNone.png" alt="" />
    </div>
    <div class="loadList">
      <div v-if="noQuestion" class="loadbtn" @click="getMore">加载更多</div>
      <div v-if="!noQuestion && pageList.length > 0" class="notDetail">没有更多内容了~</div>
    </div>
  </div>
</template>
<script>
import * as forum from "../../api/forum.js"
import { ApiToken } from '@/utils/ApiToken'
import { mapState } from 'vuex'
import { dataState } from "@/api/all.js";
import { debounce, GetWxShares } from "@/utils/common";
export default {
  name: 'mobile-forum',
  components: {
  },
  data () {
    return {
      loading: false,
      showFilter: false,
      productList_mobile: [{ text: "全部", value: 0 }],
      pageParams: {
        page: 1,
        limit: 5,
        productType: 0,  // 产品
        title: "",
      },
      selectedProductType: 0,  // 已选择产品
      categoryType: 0,  // 分类
      selectedCategoryType: 0,  // 已选择分类
      pageList: [],
      noData: false,
      noQuestion: false,
    }
  },
  computed: {
    ...mapState(['token', 'Infos']),
    showHmiTestTab() {
      // return (this.token && this.Infos.positionId == ApiToken.e3dPositionId) || this.Infos.partnerType == '10852';
      return false
    },
    showHmiChinaTab() {
      return !!(this.token && (this.Infos.isHmiTrial || String(this.Infos.partnerType) === '10852'));
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (oldval && val.query.type === oldval.query.type && val.query.article === oldval.query.article && val.query.tab === oldval.query.tab) {
          return;
        }
        this.loading = true;
        if (val.query.tab === 'hmi' || val.query.article === 'hmichina') {
          this.categoryType = 4;
        } else if (val.query.article === 'question') {
          this.categoryType = 2;
        } else if (val.query.article === 'hmiTest' || val.query.article === 'hmtion') {
          this.categoryType = 3;
        } else if (val.query.article === 'real') {
          this.categoryType = 1;
        } else if (!val.query.article && !val.query.tab) {
          // 仅 type 变化且原先也无 Tab 标识时，保留当前 Tab（兼容未同步 URL 的点击）
          const typeOnlyChange = oldval &&
            String(val.query.type) !== String(oldval.query.type) &&
            !oldval.query.article && !oldval.query.tab;
          if (!typeOnlyChange) {
            this.categoryType = 0;
          }
        }
        this.type = Number(val.query.type) || 0;
        this.resetProductParams(this.type);
        this.getList()
        
        // 数据统计
        const data ={
          "visitType": 1,
          "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
          "url": window.location.href,
          "pageUrl": "Forum",
          "relationId": val.query.type
        }
        dataState(data).then(res => {
          sessionStorage.setItem('gid',res.data);
        });
      },
      deep: true,
    },
    showHmiTestTab(val) {
      if (!val && this.categoryType === 3) {
        this.categoryType = 0;
        this.fetchCurrentTabData();
      }
    },
  },
  created () {
  },
  mounted () {
    if (this.$route.query.tab === 'hmi' || this.$route.query.article === 'hmichina') {
      this.categoryType = 4;
    } else if (this.$route.query.article && this.$route.query.article == 'question') {
      this.categoryType = 2;
    } else if (this.$route.query.article && (this.$route.query.article == 'hmtion' || this.$route.query.article == 'hmiTest')) {
      this.categoryType = 3;
    } else if (this.$route.query.article && this.$route.query.article == 'real') {
      this.categoryType = 1;
    } else {
      this.categoryType = 0;
    }
    const share = {
      title: this.$route.meta.title,
      desc: ''
    }
    GetWxShares(share);
    if (this.$route.query.code) {
      this.shareNum(this.$route.query.id);
    }
    this.getProduct()

    // 数据统计
    const data ={
      "visitType": 1,
      "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
      "url": window.location.href,
      "pageUrl": "Forum",
      "relationId": this.$route.query.type
    }
    dataState(data).then(res => {
      sessionStorage.setItem('gid',res.data);
    });
  },
  destroyed () {
  },
  methods: {
    // !获取左侧产品
    getProduct() {
      forum.getProduct().then((res) => {
        if (res.status == 1) {
          var data = []
          res.data.products.map(item => {
            if(item.extend2 == '' || item.extend2 == '驭剑'){
            data.push(item)
            }
          })
          this.productList_mobile.push(...data);
          if (this.$route.query.type) {
            const routeType = Number(this.$route.query.type) || 0;
            const matched = this.productList_mobile.find(item => item.value == routeType);
            if (matched) {
              this.resetProductParams(matched.value);
              this.getList();
            }
          } else {
            this.resetProductParams(this.productList_mobile[0].value);
            this.getList();
          }
        }
      });
    },
    resetProductParams(productType) {
      this.pageParams.page = 1;
      this.pageParams.productType = productType;
      this.selectedProductType = productType
    },
    fetchCurrentTabData() {
      // if (this.tab_current === 0) {
      //   this.getRank();
      // } else if (this.tab_current === 1) {
      //   this.getReal();
      // } else if (this.tab_current === 2) {
      //   this.getQuestion();
      // } else if (this.tab_current === 3) {
      //   this.getHmiTest();
      // } else if (this.tab_current === 4) {
      //   this.getHmiChina();
      // }
    },
    toSec(href) {
      if(!href) return
      if(this.$store.state.token){
        this.$router.push(href);
      } else {
        this.$toast({
          message: "请登录后查看!",
          duration: 1000,
        });
      }
    },
    search() {
      this.pageParams.page = 1;
      this.getList()
    },
    handleClickProduct (item) {
      this.selectedProductType = item.value
    },
    handleClickCategory (index) {
      this.selectedCategoryType = index
    },
    handleShowFilter () {
      this.showFilter = true
      this.selectedCategoryType = this.categoryType
      this.selectedProductType = this.pageParams.productType
    },
    handleClickFilterReset () {
      this.resetProductParams(this.productList_mobile[0].value)
      this.params.title = ''
    },
    handleClickFilterConfirm () {
      this.pageParams.productType = this.selectedProductType
      this.categoryType = this.selectedCategoryType
      this.showFilter = false
      this.pageParams.page = 1;
      this.getList()
    },
    async getList(isMore) {
      this.loading = true
      let res
      if (this.categoryType == 0) {
        res = await forum.getHotApp(this.pageParams)
      } else if (this.categoryType == 1) {
        res = await forum.getRealApp(this.pageParams)
      } else if (this.categoryType == 2) {
        res = await forum.questionList(this.pageParams)
      } else if (this.categoryType == 3) {
        res = await forum.HMITestPCList(this.pageParams)
      } else if (this.categoryType == 4) {
        res = await forum.HMIChinaPCList(this.pageParams)
      }
      if (res.status == 1) {
        if (res.data.length == 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        res.data.map((item) => this.parseForumListItem(item));
        if (isMore) {
          this.pageList = this.pageList.concat(res.data);
        } else {
          this.pageList = res.data;
        }
        if (this.pageList.length < res.recordCount) {
          this.noQuestion = true;
        } else {
          this.noQuestion = false;
        }
      } else {
        this.$toast(res.message);
      }
      this.loading = false
    },
    getMore() {
      this.pageParams.page++
      this.getList(true)
    },
    parseForumListItem(item) {
      if (item.industry != "") {
        item.industry = JSON.parse(item.industry);
        item.industryName = JSON.parse(item.industryName);
      } else {
        item.industry = [];
        item.industryName = [];
      }
      if (item.product != "") {
        item.product = JSON.parse(item.product);
        item.productName = JSON.parse(item.productName);
      } else {
        item.product = [];
        item.productName = [];
      }
      item.link = ApiToken.shareUrl + "Home/forumDetails?id=" + item.id;
      return item
    },
    // !复制链接
    onCopy(e) {
      this.shareNums(e.text.split("id=")[1]);
      this.$toast({ message: "复制成功!", duration: 1000 });
    },
    // !记录分享次数
    shareNums(id) {
      const Id = { forumManagementId: id };
      forum.shareNum(Id).then((res) => {});
    },
    // !分享新浪微博
    toSina(title, id) {
      this.shareNums(id);
      var url = ApiToken.shareUrl + "Home/forumDetails?id=" + id;
      url = encodeURIComponent(url);
      var a = screen.width / 2 - 300,
        d = screen.height / 2 - 175;
      window.open(
        "http://v.t.sina.com.cn/share/share.php?title=" + title + "&url=" + url,
        "Ignite",
        "status=0,toolbar=0,location=0,menubar=0,directories=0,resizable=1,scrollbars=0,width=800,height=530,top=" +
          d +
          ",left=" +
          a
      );
    },
    // !去详情页
    toDetails(id) {
      this.$router.push("/Home/forumDetails?id=" + id);
    },
    // !收藏
    collect(item) {
      if(!this.$store.state.token){
        this.$toast("请登录后操作!");
        return false;
      }
      debounce(() => {
        if (!item.isCollect) {
          forum.collectArticle({forumManagementId: item.id,}).then((res) => {
            if (res.status == 1) {
              if (res.message > 0) {
                this.$toast("收藏成功！ +" + res.message + " 积分");
              }else{
                this.$toast("收藏成功！")
              }
              item.isCollect = true;
              item.collectCount++;
            }else{
              this.$toast(res.message)
            }
          });
        } else {
          forum.collectCancelArticle({forumManagementId: id}).then((res) => {
            this.$toast({
              message: res.message,
              duration: 1000,
            });
            if (res.status == 1) {
              item.isCollect = false;
              item.collectCount--;
            }
          });
        }
      }, 1000);
    },
    // !点赞
    like(item) {
      if(!this.$store.state.token){
        this.$toast({
          message: "请登录后操作!",
        });
        return false;
      }
      debounce(() => {
        if (!item.isLike) {
          forum.likeArticle({ forumManagementId: item.id }).then((res) => {
            if (res.status == 1) {
              if (res.message > 0) {
                this.$toast("点赞成功！ +" + res.message + " 积分");
              } else {
                this.$toast("点赞成功！");
              }
              item.isLike = true
              item.likeCount++
            }
          });
        } else {
          forum.likeCancelArticle({ forumManagementId: item.id }).then((res) => {
            this.$toast({ message: res.message, duration: 1000 });
            if (res.status == 1) {
              item.isLike = false
              item.likeCount--
            }
          });
        }
      }, 1000);
    },
  }
}
</script>
<style lang='scss' scoped>
.mobile-forum{
  padding: vw(24) vw(28);
  background-color: #F8F8F8;
  min-height: 80vh;
}
.mobile-forum-nav{
  display: flex;
  align-items: center;
  gap: vw(6);
  >.item{
    display: flex;
    align-items: center;
    justify-content: center;
    height: vw(76);
    gap: vw(12);
    flex: 1;
    color: #363D42;
    background-color: #EDEDED;
    font-size: vw(24);
    &.actived{
      color: #fff;
      background-color: #6B04A8;
    }
    &:nth-of-type(1) {
      svg{
        width: vw(30);
        height: vw(26);
      }
    }
    &:nth-of-type(2) {
      svg{
        width: vw(24);
        height: vw(28);
      }
    }

    &:nth-of-type(3) {
      svg{
        width: vw(26);
        height: vw(25);
      }
    }
  }
}
.search-box{
  margin-top: vw(24);
  display: flex;
  align-items: center;
  gap: vw(20);
}
.search-input{
  flex: 1;
  border: vw(3) solid #6B04A8;
  border-radius: vw(16);
  display: flex;
  align-items: center;
  height: vw(70);
  padding: 0 vw(20);
  gap: vw(10);
  >.icon{
    height: vw(36);
    width: vw(36);
    flex-shrink: 0;
    color: #6B04A8;
  }
  >.input{
    outline: none;
    border: none;
    flex: 1;
    background-color: transparent;
  }
}
.search-filter{
  display: flex;
  align-items: center;
  font-size: vw(24);
  color: #6B04A8;
  gap: vw(6);
}
.list-box{
  margin-top: vw(40);
  display: flex;
  flex-direction: column;
  gap: vw(36);
}
.list-item{
  background-color: #fff;
  padding: vw(26) vw(22);
  position: relative;
  >.rank_icon{
    position: absolute;
    top: vw(-16);
    left: vw(-9);
    width: vw(75);
    &.inner{
      top: 0;
      left: 0;
      width: vw(85);
    }
  }
  .item-info{
    display: flex;
    align-items: center;
    gap: vw(16);
    >.avatar{
      height: vw(66);
      width: vw(66);
      >img{
        max-width: 100%;
        max-height: 100%;
        object-fit: cover;
      }
    }
    >.info{
      >.name{
        display: flex;
        align-items: center;
        color: #333;
        font-size: vw(24);
        gap: vw(8);
      }
      >.time{
        color: #BECCD6;
        font-size: vw(20);
        margin-top: vw(4);
      }
    }
  }
  .item-text{
    line-height: vw(40);
    margin-top: vw(20);
    margin-bottom: vw(22);
    >.title{
      font-size: vw(24);
      font-weight: bold;
    }
    >.text{
      font-size: vw(24);
      position: relative;
      max-height: vw(240);
      overflow: hidden;
      >.more{
        font-size: vw(24);
        color: #4D69E0;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: #fff;
        z-index: 1;
        padding: 0 vw(8);
      }
    }
  }
  .item-imgs{
    display: grid;
    align-items: center;
    gap: vw(8);
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-bottom: vw(24);
    >img{
      max-width: 100%;
      aspect-ratio: 1;
      object-fit: cover;
    }
  }
  .item-control-box{
    border-top: vw(1) solid #F2F5F7;
    padding-top: vw(24);
    display: flex;
    justify-content: space-between;
    >.item{
      display: flex;
      align-items: center;
      gap: vw(6);
      color: #363D42;
      position: relative;
      z-index: 3;
      >svg{
        object-fit: contain;
      }
      >.text{
        font-size: vw(24);
        min-width: vw(30);
      }
      &.active{
        background-color: transparent;
      }
      &:hover>.share-list{
        display: block;
      }
      >.share-list{
        display: none;
        position: absolute;
        box-shadow: 0 4px 9px 1px rgba(96, 96, 96, .4);
        border-radius: 8px;
        padding: 0;
        top: vw(50);
        right: vw(-30);
        background-color: #fff;
        z-index: 1;
        width: vw(280);
        >li{
          line-height: vw(80);
          display: flex;
          padding-left: 0;
          justify-content: center;
          align-items: center;
          gap: vw(24);
          >img{
            width: vw(44);
          }
          >span{
            color: #6c7179;
            font-size: vw(24);
          }
        }
      }
    }
  }
}
.aveva-badge{
  text-indent: vw(52);
  font-size: vw(24);
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  height: vw(48);
  width: vw(168);
  line-height: vw(48);
}
.popup-box{
  padding: vw(50);
  padding-bottom: vw(150);
  .popup-item{
    display: flex;
    flex-direction: column;
    gap: vw(20);
    margin-bottom: vw(40);
    >.title{
      color: #363D42;
      font-size: vw(24);
      font-weight: bold;
    }
    >.tags{
      display: flex;
      align-items: center;
      gap: vw(28);
      flex-wrap: wrap;
      >.tag{
        display: flex;
        align-items: center;
        height: vw(36);
        background-color: #ededed;
        color: #363D42;
        border-radius: vw(8);
        padding: 0 vw(20);
        font-size: vw(20);
        &.selected{
          background-color: #f4e3ff;
          color: #6B04A8;
        }
      }
    }
  }
  .popup-btn-box{
    margin-top: vw(60);
    display: flex;
    align-items: center;
    gap: vw(26);
    >.btn{
      flex: 1;
      text-align: center;
      height: vw(72);
      line-height: vw(72);
      background-color: #ededed;
      font-size: vw(24);
      font-weight: 500;
      border-radius: vw(8);
      color: #000;
      &.cur{
        background-color: #6B04A8;
        color: #fff;
      }
    }
  }
}
.noData{
  display: flex;
  justify-content: center;
  >img{
    width: vw(400);
  }
}
.loadList{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: vw(40) 0;
}
.loadbtn{
  padding: vw(14) vw(20);
  background: #eee;
}
.notDetail{
  color: #ccc;
  font-size: vw(24);
}
</style>